import React, { Component } from 'react';
import './App.css';


class Screenshot extends Component {
	constructor (props) {
		super(props)
		this.onLoad = this.onLoad.bind(this)
		this.handleClick = this.handleClick.bind(this)
		//src,imgkey,height,width
		//console.log("next SS is"+JSON.stringify(this.props))
    }

    onLoad(){
    	//console.log("loaded:"+this.props.src)
    }
	
	handleClick (){
		this.props.controller(this.props,true)
		//console.log("props is"+JSON.stringify(this.props))
		//resetOverlayCounter on Overlay

		//this.props.controller.displayOverlay(img)
	}

  render() {

    return (
    	<img src={require(`${this.props.src}`)} onClick={this.handleClick} onLoad={this.onLoad} key={this.props.key} height={this.props.height} width={this.props.width} className="screenImgThumb" alt="test"/>
    );
  }
}

export default Screenshot;


// WEBPACK FOOTER //
// ./src/Screenshot.js